/* kwadwo.7 sign-up -> Kit.
   Each site form posts to a Kit form. Kit adds the subscriber and sends the sheet email.
   Form attributes (all optional):
     data-kit-form  Kit form ID (default 9977367, "Colour Combo Sheet")
     data-ok        message shown after sign-up
     data-redirect  page to send them to after sign-up
   Also opens the Silhouette Sheet pop-up from any [data-kw-open-silhouette] link
   or when the page is visited with #silhouette-sheet. */
(function () {
  var DEFAULT_FORM = '9977367';
  var DEFAULT_OK = "You're in. Check your inbox, your Colour Combo Sheet is on its way.";

  document.querySelectorAll('[data-kw-signup]').forEach(function (form) {
    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button[type="submit"]');
    var err = form.querySelector('[data-kw-signup-err]');
    var label = btn ? btn.textContent : '';
    var busy = false;
    var kitForm = form.getAttribute('data-kit-form') || DEFAULT_FORM;
    var okText = form.getAttribute('data-ok') || DEFAULT_OK;
    var redirect = form.getAttribute('data-redirect');

    function showErr(msg) {
      if (!err) return;
      err.textContent = msg;
      err.hidden = false;
    }
    function reset() {
      busy = false;
      if (btn) { btn.disabled = false; btn.textContent = label; }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      if (err) err.hidden = true;
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showErr('Please enter a valid email address.');
        input.focus();
        return;
      }
      busy = true;
      if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }

      var fd = new FormData();
      fd.append('email_address', email);
      fetch('https://app.kit.com/forms/' + kitForm + '/subscriptions', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status === 'success') {
            var msg = document.createElement('p');
            msg.className = 'kw-subscribe__msg kw-subscribe__msg--ok';
            msg.setAttribute('role', 'status');
            msg.textContent = okText;
            form.replaceWith(msg);
            if (redirect) setTimeout(function () { window.location.href = redirect; }, 1200);
            return;
          }
          var m = data && data.errors && data.errors.messages && data.errors.messages[0];
          showErr(m || 'Something went wrong. Please try again.');
          reset();
        })
        .catch(function () {
          showErr('Could not connect. Please check your connection and try again.');
          reset();
        });
    });
  });

  /* Silhouette Sheet pop-up */
  var dlg = document.getElementById('kw-silhouette-dialog');
  if (!dlg) return;
  function openDlg(e) {
    if (e) e.preventDefault();
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    var input = dlg.querySelector('input[type="email"]');
    if (input) setTimeout(function () { input.focus(); }, 60);
  }
  function closeDlg() {
    if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
  }
  document.querySelectorAll('[data-kw-open-silhouette]').forEach(function (a) { a.addEventListener('click', openDlg); });
  dlg.querySelectorAll('[data-kw-close]').forEach(function (b) { b.addEventListener('click', closeDlg); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) closeDlg(); });
  if (window.location.hash === '#silhouette-sheet') openDlg();
})();
